export default {
    DATA: 'DD/MM/YYYY',
    DATA_HORA: 'DD/MM/YYYY HH:mm:ss',
    DATA_HORA_MINUTO: 'DD/MM/YYYY [-] HH[h] mm[min]'
}
